const useTableRowConfig = (config) => {
  if (!Array.isArray(config)) return { tableRowConfig: [] };

  const hasElasticColumn = config.some((column) => column?.grow === true);
  if (hasElasticColumn) return { tableRowConfig: config };

  const lastIdx = config.length - 1;
  if (lastIdx < 0) return { tableRowConfig: config };

  const tableRowConfig = config.map((column, idx) =>
    idx === lastIdx ? { ...column, grow: true } : column
  );
  return { tableRowConfig };
};

export default useTableRowConfig;
